import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const verticalItem = css`
  background-color: ${cssTheme.default.day.backgroundMinor};
  padding: ${spacing(1.5)};
  border-radius: ${spacing(2)};
  block-size: ${spacing(13.5)};
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;

  &:hover {
    background-color: ${cssTheme.components.buttons.default.bgColorHovered};
  }

  &:active {
    background-color: ${cssTheme.components.buttons.default.bgColorPressed};
  }
`

export const image = css`
  block-size: ${spacing(4.75)};
  inline-size: ${spacing(11)};
  object-fit: contain;
`

export const wrapper = {
  top: css`
    inline-size: 100%;
  `,
  content: css`
    margin-top: auto;
  `,
}

export const radio = css`
  ${cssTheme.default.day.controlMinor.token}: ${hex2rgba(cssTheme.default.day.text.hex, 0)};
`

export const badgeContainer = css`
  margin-inline-start: ${spacing(0.5)};
  flex: 1;
`

export const badgeNew = css`
  background-color: ${cssTheme.colors.cinnabar.toxic};
  box-shadow: 0 2px 5px 0 ${hex2rgba(cssTheme.colors.cinnabar.toxic.hex, 0.3)};
  opacity: 100%;
  padding: ${spacing(0.25, 0.5)};
  border-radius: ${spacing(12.5)};
  inline-size: fit-content;
`

export const businessBadge = css`
  position: absolute;
  inset-block-start: -4px;
  inset-inline-end: -4px;
  background: linear-gradient(108.41deg, #21211f 38.67%, rgba(33, 32, 31, 0.2) 59.9%, #21211f 81.77%);
  padding: 2px 4px;
  border-radius: 100px;
`

export const title = css`
  flex: 1.5;
`
